import { useQuery } from "@tanstack/react-query";

export function useReadAllBlockComments(ceremonyId: number, blockId: number) {
    return useQuery<any>([`ceremonies/${ceremonyId}/blocks/${blockId}/comments`], {
        refetchOnWindowFocus: false
    });
}
